const sidebar = false;

const entity = {
  title: "Programmes",
  actions: {
    sort: {
      endPoint: "programmes/by",
      query: {
        $order: {},
      }
    },
    get: {
      endPoint: "programmes/by",
      query: {}
    },
    create: {
      endPoint: "programmes"
    },
    filter: {
      endPoint: "programmes/by",
      query: {
        $group: "id",
        $where: {}
      }
    }
  }
};

const keys = [{
  dataTableID: "id",
  label: "Id",
  tooltip: "ID used to generate this report",
  columnType: "string",
  table: {
    displayOrder: 1
  },
  filter: {
    displayOrder: 1,
    columnType: "select",
    matchType: "", // Values can be gte, lte, gt, lt, By default it is eq
    options: {
      select: [{
        field: "id"
      }],
      title: ["id"],
      value: "id",
      endPoint: "programmes/by",
      separator: " ",
      initializer: ""
    }
  }
},
{
  dataTableID: "name",
  tooltip: "Name of the programme",
  label: "Name",
  columnType: "string",
  create: {
    displayOrder: 1
  },
  table: {
    displayOrder: 2
  },
  filter: {
    displayOrder: 2
  }
},
{
  dataTableID: "description",
  tooltip: "Description of the programme",
  label: "Description",
  columnType: "string",
  create: {
    displayOrder: 2
  },
  table: {
    displayOrder: 3
  }
}
];

const tabs = [{
  view: "detailView",
  entity: "academies",
  endPoint: "programmes/by",
  title: "Details",
  queryFilter: {
    id: ":id"
  }
}];

export {
  sidebar,
  entity,
  keys,
  tabs
};